import { ca } from '@cian/analytics';

import { EEntityType } from '../../types/filters';

export const trackDealTypeClick = (label: EEntityType | null) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'ListingFavorites',
    label: label ? 'newbuilding' : 'offer',
    page: {
      extra: {
        favorite_pagetype: label ? 'newbuilding' : 'offer',
      },
    },
  });
};

export const trackSavedSearchClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'ListingFavorites',
    label: 'savedsearch',
    page: {
      extra: {
        favorite_pagetype: 'savedsearch',
      },
    },
  });
};

export const trackComparisonClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'ListingFavorites',
    label: 'comparison',
    page: {
      extra: {
        favorite_pagetype: 'comparison',
      },
    },
  });
};
